var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"payment-provider",attrs:{"id":"payment-page"}},[_c('div',{staticClass:"payment-container"},[_c('div',{ref:'card',staticClass:"payment"})])])}
var staticRenderFns = []

export { render, staticRenderFns }